<template>
  <permissions-view
    :site="site"
    :section="section"
  >
    <v-container>
      <v-form
        v-model="valid"
        ref="form"
      >
        <v-row>
          <v-col cols="3">
            <hub-site
              :readonly="isReadOnly()"
              label="HUB site"
              :value="getValue(transmission, 'hub_site')"
              @input="setValue(transmission, 'hub_site', $event)"
            ></hub-site>
          </v-col>
          <v-col cols="3">
            <hub-importance
              :readonly="isReadOnly()"
              label="HUB importance"
              :value="getValue(transmission, 'hub_importance')"
              @input="setValue(transmission, 'hub_importance', $event)"
            ></hub-importance>
          </v-col>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              label="# of connected sites"
              :value="getValue(transmission, 'number_connected_sites')"
              @input="setValue(transmission, 'number_connected_sites', $event)"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <site-select
              :readonly="isReadOnly()"
              label="Protection for site"
              :value="getValue(transmission, 'protection_for_site')"
              @input="setValue(transmission, 'protection_for_site', $event)"
            ></site-select>
          </v-col>
          <v-col cols="3">
            <s-textarea
              :readonly="isReadOnly()"
              label="HUB site comment"
              :value="getValue(transmission, 'comment')"
              @input="setValue(transmission, 'comment', $event)"
            ></s-textarea>
          </v-col>
          <v-col cols="3">
            <switch-button
              :readonly="isReadOnly()"
              label="Redundancy"
              :value="getValue(transmission, 'redundancy')"
              @change="setValue(transmission, 'redundancy', $event)"
            ></switch-button>
          </v-col>
          <v-col cols="3">
            <s-textarea
              :readonly="isReadOnly()"
              label="Redundancy description"
              :value="getValue(transmission, 'redundancy_description')"
              @input="setValue(transmission, 'redundancy_description', $event)"
            ></s-textarea>
          </v-col>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              label="Power consumption (W)"
              :value="getValue(transmission, 'power_consumption')"
              @input="setValue(transmission, 'power_consumption', $event)"
            ></text-field>
          </v-col>
        </v-row>
        <form-actions
          v-if="!isReadOnly()"
          :loading="loading"
          :saved="saved"
          v-on:saveData="saveData"
        />
      </v-form>
      <empty-space />
      <h2>Equipment</h2>
      <transmission-equipment-list
        :site="site"
        :value="getValue(transmission, 'equipment')"
        @input="setValue(transmission, 'equipment', $event)"
      />
    </v-container>
  </permissions-view>
</template>

<script>
  import HubImportance from '@/components/codelist/HUBImportance'
  import HubSite from '@/components/codelist/HUBSite'
  import DisplayField from '@/components/DisplayField'
  import STextarea from '@/components/Textarea'
  import SwitchButton from '@/components/SwitchButton'
  import TextField from '@/components/TextField'
  import TransmissionEquipmentList from '@/views/sites/sections/transmission-equipment/TransmissionEquipmentList'
  import SiteTransmissionService from '@/services/site-transmission'
  import ReactivityMixin from '@/mixins/Reactivity'
  import ValidationMixin from '@/mixins/Validation'
  import FormActions from '@/components/FormActions'
  import PermissionsView from '@/components/PermissionsView'
  import PermissionsMixin from '@/mixins/Permissions'
  import EmptySpace from '@/components/EmptySpace'
  import SiteSelect from '@/components/codelist/SiteSelect'

  export default {
    name: 'Transmission',
    mixins: [
      ReactivityMixin,
      ValidationMixin,
      PermissionsMixin,
    ],
    components: { SiteSelect, EmptySpace, PermissionsView, FormActions, TransmissionEquipmentList, TextField, SwitchButton, STextarea, DisplayField, HubSite, HubImportance },
    props: {
      site: {
        default: null,
      },
      active: {
        default: false,
      },
    },
    mounted () {
      this.fetchData()
    },
    data: function () {
      return {
        valid: false,
        loading: false,
        saved: false,
        transmission: {
          equipment: [],
        },
        section: 'transmission',
      }
    },
    methods: {
      fetchData () {
        const sts = new SiteTransmissionService(this.site.id)
        sts.getSingle().then((response) => {
          this.transmission = response.data.data
          if (Array.isArray(this.transmission)) {
            this.transmission = {
              equipment: [],
            }
          }
        })
      },
      saveData () {
        this.validate()
        if (this.valid) {
          this.loading = true
          this.saved = false
          const sts = new SiteTransmissionService(this.site.id)
          sts.post(this.transmission).then((response) => {
            this.saved = true
          }).finally(() => {
            this.loading = false
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>
